module.exports = __webpack_public_path__ + "media/t_searchdemo.49662b06.webm";